import axios from "axios"

export default {
    state: {
        videos: []
    },
    getters: {
        videos(state) {
            return state.videos;
        }
    },
    mutations: {
        setVideos(state, videos) {
            state.videos = videos;
        }
    },
    actions: {
        async getVideos({ commit }) {
            let res = await axios.get(`/video_galleries`);
            let videos = res.data.data;
            commit('setVideos', videos)
        }
    }
}